

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {ILocker2} from "@/model/Locker/lockerInterfaces";
  import {IOnOffHandlers} from "bonomo";
  import {namespace} from "vuex-class";
  import {EPermissionActions} from "@/model/EPermissionActions";
  import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
  import {ILaLigaCompetition} from "@/model/LaLiga/ILaLigaCompetition";
  import {IErrors} from "@/model/IErrors";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

  const laLigaModule = namespace("laLigaModule");

  @Component({
    components: {
      SimpleConfirmationDialog
    }
  })
  export default class LLaLigaCompetition extends Vue {

    @laLigaModule.Action('fetchCompetitions')
    fetchCompetitions!: (lockerId: number) => any;
    @laLigaModule.Action('createCompetition')
    createCompetitions!: (params: { lockerId: number, startAt: string, endAt: string}) => any;

    @laLigaModule.Getter('competitions')
    competitions!: ILaLigaCompetition[];
    @laLigaModule.Getter('errors')
    errors!: IErrors;

    @Prop()
    locker!: ILocker2;
    @Prop()
    disabled!: boolean;
    @Prop()
    editing!: boolean;
    @Prop()
    loading!: boolean;

    endAt: string = '';
    endAtMenu: boolean = false;
    startAt: string = '';
    startAtMenu: boolean = false;
    submitting: boolean = false;
    subscribes: IOnOffHandlers = {};

    protected get headers(): BetterDataTableHeader[] {
      return [
        {
          text: '',
          value: 'icon',
        },
        {
          text: '',
          value: 'id',
        },
        {
          text: '',
          value: 'start_at',
        },
        {
          text: '',
          value: 'end_at',
        },
        // {
        //   text: '',
        //   value: 'actions',
        // },
      ]
    }

    get activeCompetition(): ILaLigaCompetition|undefined {
      const todayDate = new Date().toISOString().split('T')[0];
      return this.competitions
        .find(each => ((this.toDate(each.start_at) <= todayDate) && (this.toDate(each.end_at) >= todayDate)))
    }

    get canEdit(): boolean {
      return this.$canAction(EPermissionActions.ACTION_LOCKERS_UPDATE);
    }

    get lastCompetition(): ILaLigaCompetition|undefined {
      return this.competitions
        .sort((a, b) => a.end_at > b.end_at ? 1 : -1)
        .pop();
    }

    get minDate(): string {
      const date = new Date();
      date.setMonth(date.getMonth() - 6);
      return date.toISOString().split('T')[0];
    }

    created() {
      this.subscribes = this.$ons({
        // 'backend.call.OK.locker2Loaded': this.onLockerLoaded,
        'backend.call.OK.laLigaCompetitionsLoaded': this.onOK,
        'backend.call.KO.laLigaCompetitionsLoaded': this.onKO,
      });
      this.fetchCompetitions(this.locker.id);
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    isActiveCompetition(item: ILaLigaCompetition): boolean {
      return (this.activeCompetition || {} as any).id  == item.id;
    }

    onKO() {
      this.submitting = false;
    }

    onOK() {
      if (this.submitting) {
        this.startAt = '';
        this.endAt = '';
        this.submitting = false;
      }
    }

    onSubmit() {
      this.submitting = true;
      this.createCompetitions({
        lockerId: this.locker.id,
        startAt: this.startAt,
        endAt: this.endAt,
      });
    }

    onTogglePanel() {
      if (this.disabled && !this.editing) {
        return;
      }
      this.$emit('update:editing', !this.editing)
    }

    toDate(d: string): string {
      return d.substring(0,10);
    }

  }

